<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'marqueimg',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>
      <a-carousel :autoplay="true" >
        <div class="padding" v-for="(item,i) in dataSousrce" :key="i">
          <a-row :gutter="[30,30]">
            <a-col class="content-box text-center" v-for="(it,u) in item" :key="u" :md="{span:8}" :lg="{span:24/data.col}" :sm="{span:12}">
              <img :src="addip(it.pic)" style="width: 100%;height:auto;margin-bottom:15px ;" />
              <h4 >{{ it.name }}</h4>
            </a-col>
          </a-row>
        </div>
      </a-carousel>
    </div>
</template>
<script setup lang="ts" name="marqueimg">
import {defineComponent,defineProps, onMounted,ref } from 'vue';
import {addip,getCol} from '@/utils/util'
const props=defineProps({
  data:Object
})
const pageCount=ref<boolean>(1)
const dataSousrce=ref<Array>([])
onMounted(()=>{
    let list=[]
    let item=[]
     props.data.child.forEach((e,i) => {
        if((i%props.data.col==0&&i>0)){
          list.push(item)
          item=[]
        }else if(i==props.data.child.length-1){
          list.push(item)
        }
        item.push(e)
     });
     dataSousrce.value=list
})
</script>
<style lang="less">
@import '@/style/main.less';
  .marqueimg {
    .slick-dots{
      bottom: -20px;
      li{width: 50px !important;background: @gray;height:5px!important;}
      .slick-active{background: @primary;}
    }
    .ant-carousel{color:inherit;}
  }
</style>
